export default __webpack_public_path__ + "static/media/5.621463a5.jpg";